import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Huanzhezhusu"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M4.5752 2.41741V2.42855C4.5752 3.28139 5.26657 3.97091 6.11756 3.97091H9.80363C10.6565 3.97091 11.346 3.27954 11.346 2.42855V2.41649H12.0077C12.8271 2.41649 13.4906 3.08094 13.4925 3.90131V12.9466C13.4925 13.3404 13.336 13.7181 13.0576 13.9966C12.7791 14.275 12.4015 14.4315 12.0077 14.4315H3.91353C3.51973 14.4315 3.14206 14.275 2.8636 13.9966C2.58515 13.7181 2.42871 13.3404 2.42871 12.9466V3.90223C2.42871 3.50843 2.58515 3.13076 2.8636 2.85231C3.14206 2.57385 3.51973 2.41741 3.91353 2.41741H4.5752ZM7.88914 5.75176C7.61352 5.75176 7.38987 5.90767 7.38987 6.09977V8.0356L5.4531 8.03653C5.26101 8.03653 5.1051 8.25925 5.1051 8.5358C5.1051 8.81142 5.26101 9.03507 5.4531 9.03507H7.38894L7.38987 10.9718C7.38987 11.1639 7.61259 11.3198 7.88914 11.3198C8.16476 11.3198 8.38841 11.1639 8.38841 10.9718V9.03414L10.3252 9.03507C10.5173 9.03507 10.6732 8.81235 10.6732 8.5358C10.6732 8.26018 10.5173 8.03653 10.3252 8.03653H8.38748L8.38841 6.09977C8.38841 5.90767 8.16568 5.75176 7.88914 5.75176ZM9.80641 1.50146C10.0524 1.50146 10.2883 1.59919 10.4623 1.77314C10.6362 1.94709 10.734 2.18301 10.734 2.42901C10.734 2.67501 10.6362 2.91094 10.4623 3.08489C10.2883 3.25884 10.0524 3.35656 9.80641 3.35656H6.11478C5.86878 3.35656 5.63285 3.25884 5.4589 3.08489C5.28495 2.91094 5.18723 2.67501 5.18723 2.42901C5.18723 2.18301 5.28495 1.94709 5.4589 1.77314C5.63285 1.59919 5.86878 1.50146 6.11478 1.50146H9.80641Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var huanzhezhusu = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { huanzhezhusu as default };
